import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Typography, Grid, MuiThemeProvider, 
    ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import _ from 'lodash';
import {v4 as uuidv4} from 'uuid';

import DisplayGameObject from '../components/DisplayGameObject';

class PlayerEndGameDisplay extends Component {
  render() {
    const { theme, gameObjects, players } = this.props;

    return (
        <MuiThemeProvider>
            <Grid item xs={12}>
                {_.map(gameObjects, (gameObject) => {
                return <ExpansionPanel key={uuidv4()}>
                    <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    >
                        <Typography 
                            variant='h6' 
                            style={{display: 'block', backgroundColor: _.find(players, {id: gameObject.submissions[0].playerId}) ? _.find(players, {id: gameObject.submissions[0].playerId}).color : 'lightgreen', borderRadius: 5}}
                        >
                            {`${_.find(players, {id: gameObject.submissions[0].playerId }) ?  _.find(players, {id: gameObject.submissions[0].playerId}).name : "Name"}'s Game`}
                        </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Grid item xs={12} style={{width: '100%'}}>
                            {_.map(gameObject.submissions, (submission) => {
                                return <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography 
                                            variant='h6' 
                                            style={{display: 'block', backgroundColor: _.find(players, {id: submission.playerId}) ? _.find(players, {id: submission.playerId}).color : 'lightgreen', borderRadius: 5}}
                                        >
                                            {_.find(players, {id: submission.playerId }) ?  _.find(players, {id: submission.playerId}).name : "Name"}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <DisplayGameObject theme={theme} lastRoundData={submission} />
                                    </Grid>
                                </Grid>
                            })}
                        </Grid>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                })}
            </Grid>
        </MuiThemeProvider>
    );
  };
};

const styles = theme => ({});

export default withStyles(styles)(PlayerEndGameDisplay);
